var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"developing"},[_vm._v("\n  준비중입니다.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }